const envConfig = require(`./envs/${process.env.NODE_ENV}`); // eslint-disable-line import/no-dynamic-require
const baseConfig = require('./base');

const config = {
  ...baseConfig.default,
  ...envConfig.default || {},
};
config.links = 'links' in config && 'links' in envConfig.default ?
{
  ...baseConfig.default.links,
  ...envConfig.default.links,
} : config.links;

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js